// Button variant types (styling)
export const AGENT_GHOST = 'agent-ghost';
export const AGENT_PRIMARY = 'agent-primary';
export const AGENT_SECONDARY = 'agent-secondary';
export const DESTRUCTIVE = 'destructive';
export const GHOST = 'ghost';
export const LINK = 'link';
export const NEGATIVE = 'negative';
export const PRIMARY = 'primary';
export const PROMOTIONAL = 'promotional';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';

export const BUTTON_TYPES = Object.freeze([
  AGENT_GHOST,
  AGENT_PRIMARY,
  AGENT_SECONDARY,
  DESTRUCTIVE,
  GHOST,
  LINK,
  NEGATIVE,
  PRIMARY,
  PROMOTIONAL,
  SECONDARY,
  TERTIARY,
]);

// HTML button type attribute values
export const TYPE_BUTTON = 'button';
export const TYPE_RESET = 'reset';
export const TYPE_SUBMIT = 'submit';

export const HTML_BUTTON_TYPES = Object.freeze([TYPE_BUTTON, TYPE_RESET, TYPE_SUBMIT]);

export default {
  AGENT_GHOST,
  AGENT_PRIMARY,
  AGENT_SECONDARY,
  BUTTON_TYPES,
  DESTRUCTIVE,
  GHOST,
  HTML_BUTTON_TYPES,
  LINK,
  NEGATIVE,
  PRIMARY,
  PROMOTIONAL,
  SECONDARY,
  TERTIARY,
  TYPE_BUTTON,
  TYPE_RESET,
  TYPE_SUBMIT,
};
